import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import { useSpring, animated } from "react-spring"; // web.cjs is required for IE 11 support
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import CloseIcon from "@material-ui/icons/Close";
import { Button } from "@material-ui/core";
import { useDataLayerValue } from "../Reducer/DataLayer";

const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

Fade.propTypes = {
  children: PropTypes.element,
  in: PropTypes.bool.isRequired,
  onEnter: PropTypes.func,
  onExited: PropTypes.func,
};

export default function MyModal(props) {
  const [{ isMobile }, dispatch] = useDataLayerValue();

  const classes = useStyles({ isMobile });

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  console.log(isMobile);
  return (
    <div className="text-left">
      <div type="button" onClick={handleOpen} className={classes.modalButton}>
        {props.img}
      </div>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <CloseIcon className="cross" onClick={() => setOpen(false)} />
            {props?.buttonsTrue && (
              <NavigateNextIcon
                variant="text"
                color="primary"
                className="prev svg"
                onClick={() => console.log("prev")}
              />
            )}
            {props.children}
            {props?.buttonsTrue && (
              <NavigateNextIcon
                variant="text"
                color="primary"
                className="next svg"
                onClick={() => console.log("prev")}
              />
            )}
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

const useStyles = makeStyles((theme, props) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#e6e5e1",
    display: "flex",
    alignItems: "center",
    width: "90vh",
    height: "80vh",
    position: "relative",
    borderRadius: ".5rem",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: (props) => (props.isMobile ? "45vh" : "81vh"),
      height: (props) => (props.isMobile ? "40vh" : "72vh"),
    },
    "& .cross": {
      position: "absolute",
      top: 0,
      right: 0,
      zIndex: 10,
      margin: ".325rem  .325rem 0 0",
      fontSize: "2.0rem",
      opacity: 0.7,
      color: "white",
      backgroundColor: "black",
      borderRadius: "5rem",
      cursor: "pointer",
      "&:hover": {
        transform: "scale(1.1)",
      },
    },
    "& .next": {
      right: "0rem",
      "&:active": {
        transform: "scale(1.15)",
      },
    },
    "& .prev": {
      left: "0rem",
      transform: "rotate(180deg)",
      "&:active": {
        transform: "scale(1.15) rotate(180deg)",
      },
    },
    "& .svg": {
      color: "white",
      borderRadius: " 5rem",
      fontSize: "2.5rem",
      fontWeight: 2000,
      textAlign: "center",
      margn: "auto",
      zIndex: 10,
      opacity: 0.5,
      margin: "0 0.55rem",
      backgroundColor: "#5e5d5a",
      position: "absolute",
    },

    "& .svg:hover": {
      backgroundColor: "#5e5d5a",
      opacity: 0.9,
    },
  },
}));
